module.exports = __webpack_public_path__ + "img/member-shape-st3.85d09428.png";